import React from "react";
import {TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {
    getFeConfig,
    operator_users,
    userNotificationSubscription,
    submitNotificationSubscription,
    disableUserAccess,
    resetPassword
} from "../api/api";
import {Button, Modal, Switch, notification} from "antd";
import {EyeOutlined} from '@ant-design/icons'
import Checkbox from "antd/es/checkbox/Checkbox";
import '../styles/OperatorUserManagement.css'
import {DefaultProps, RefTable} from "./RefTable";

export const NotificationSubscribeTable = ({onSubmit, onCancel, user}) => {

    return <div className={`message_subscription`}>
        <TableV2
            schema = {'message_subscription'}
            fetchConfig={async (schema) => {
                const {data: {rows = []} = {}} = await getFeConfig(schema) || {}
                return { data: { statusCode : 200, rows: rows } };
            }}
            fetchData={async () => {
                const {email} = user
                const {data: {rows}} = await userNotificationSubscription(email)
                const {data: {rows: message_types}} = await getFeConfig('message_types') || {}

                const Data = []
                for (const message_type of message_types) {
                    const name = message_type.name
                    Data.push({
                        "name": message_type.name,
                        "message_type": message_type.title,
                        "notify": rows[0] ? rows[0][`${name}`] : false
                    })
                }
                return {data: {rows: Data, statusCode: 200}}
            }}
            customRenderer={{
                notify: (value, row, index, column)=>{
                    const onChange = async (e) => {
                        const obj  = {}
                        const rowName = row.name
                        obj[`${rowName}`] = e.target.checked
                        await submitNotificationSubscription(obj, user);
                    };
                    return [
                        <Checkbox onChange={onChange} defaultChecked={row.notify}/>
                    ]
                },
            }}
        >
        </TableV2>
    </div>
}

export const OperatorUserManagement = (props)=><RefTable {...props}/>;

OperatorUserManagement.defaultProps = {
    ...DefaultProps,
    title: "Operator Users",
    tableSchema: "operator_user_management",
    add: false,
    fetch: async (tableName, filters = {}, page = {})=> operator_users({page,query: filters}),
    tableName: "dashboard_users",
    edit: false,
    filterSchema: "user_filter",
    tfootHeight: 50,
    customRenderer: {
        assign_message: (value, row, index, column)=>{
            return [
                <Button key={'btn'} icon={<EyeOutlined />} onClick={async () =>{
                    Modal.info({
                        title: `Assign Message Type`,
                        content: <React.Fragment>
                            <NotificationSubscribeTable onSubmit={()=> {
                                return true;
                            }} user={ {email : row.email, firstname : row.firstName, lastname : row.lastName }}/>
                        </React.Fragment>,

                        okType: "ghost",
                        okText: "Close",
                        maskClosable: true,
                        closable: true,
                        keyboard: true,
                        bodyStyle: {overflowX: 'scroll', overflowY: 'scroll', width: 'fit-content', height: '60vh', maxWidth: '75vw'},
                        width: 'fit-content'
                    })
                }}/>
            ]
        },
        reset_password: (value, row, index, column)=>{
            return [
                <Button onClick={async () => {
                    const {status} = await resetPassword(row.email) || {}
                    if(status === 200) {
                        notification.success({message: `Password reset link sent to the email address [${row.email}]`})
                    }
                }}>Reset Password</Button>
            ]
        },
        block_user: (value, row, index, column)=>{
            const onChange = async (checked) => {
                await disableUserAccess(!checked, row.id);
            };
            return [
                <Switch defaultChecked={!row.enabled} onChange={onChange} />
            ]
        }
    }
}
